import { render, staticRenderFns } from "./PersonalInfo1.vue?vue&type=template&id=1c58f1da"
import script from "./PersonalInfo1.vue?vue&type=script&lang=js"
export * from "./PersonalInfo1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c58f1da')) {
      api.createRecord('1c58f1da', component.options)
    } else {
      api.reload('1c58f1da', component.options)
    }
    module.hot.accept("./PersonalInfo1.vue?vue&type=template&id=1c58f1da", function () {
      api.rerender('1c58f1da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/PersonalInfo1.vue"
export default component.exports